import { H4 } from "@evergis/ui";
import styled from "styled-components";

import { catalogCompactWidth, catalogInDialogCompactWidth, catalogInDialogWidth, catalogWidth } from "../../styled";

import cards from "../../assets/cards.svg";

export const CardGroupContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 23.5rem;
  height: 18rem;

  @media screen and (max-height: 44rem) {
    width: 20.5rem;
    height: 19.5rem;
  }
`;

export const CardsBlank = styled.div`
  background: url(${cards}) center center no-repeat;
  height: 210px;
  width: 247px;
  margin-bottom: 1.3rem;
`;

export const NoResourceDescription = styled(H4)`
  color: ${({ theme: { palette } }) => palette.textPrimary};
  white-space: pre;
  text-align: center;
`;

type CardGroupContainerProps = {
  dialog?: boolean;
};

export const CardGroupContainer = styled.div<CardGroupContainerProps>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 23.5rem;
  overflow-y: auto;

  ${({ dialog }) => (dialog ? catalogInDialogWidth : catalogWidth)};
  ${({ dialog }) => (dialog ? catalogInDialogCompactWidth : catalogCompactWidth)};
`;
